module.exports = __webpack_public_path__ + "static/media/17.dc2225f2.mp3";